"use client";

import type { ScoreBreakdown } from "@/types/portfolio-builder.types";

interface Props {
  scores: ScoreBreakdown;
}

const DIMENSIONS = [
  { key: "riskAlignment" as const, label: "Risk Alignment", weight: "25%" },
  { key: "returnFit" as const, label: "Return Fit", weight: "25%" },
  { key: "riskAdjustedReturn" as const, label: "Risk-Adj Return", weight: "15%" },
  { key: "diversification" as const, label: "Diversification", weight: "15%" },
  { key: "experience" as const, label: "Experience", weight: "10%" },
  { key: "budgetUtilization" as const, label: "Budget Utilization", weight: "10%" },
];

function getBarColor(score: number): string {
  if (score >= 80) return "bg-green-500";
  if (score >= 60) return "bg-blue-500";
  if (score >= 40) return "bg-amber-500";
  return "bg-red-500";
}

export function ScoreBreakdownChart({ scores }: Props) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold">Score Breakdown</h3>
        <span className="text-lg font-bold text-blue-400">
          {scores.totalScore.toFixed(1)}
        </span>
      </div>
      <div className="space-y-2">
        {DIMENSIONS.map(({ key, label, weight }) => {
          const score = scores[key];
          return (
            <div key={key} className="space-y-0.5">
              <div className="flex items-center justify-between text-xs">
                <span className="text-gray-400">
                  {label} <span className="text-gray-600">({weight})</span>
                </span>
                <span className="font-medium">{score.toFixed(1)}</span>
              </div>
              <div className="h-2 overflow-hidden rounded-full bg-gray-800">
                <div
                  className={`h-full rounded-full transition-all ${getBarColor(score)}`}
                  style={{ width: `${Math.min(100, score)}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
